/**
 * Lib Cookies module
 */

Lib.Cookies = {

    /**
     *
     * @param name
     * @param value
     * @param expires
     * @returns {boolean}
     */
    set: function(name, value, expires) {

        // If we didnt pass a date instance in the expires argument
        if (!(expires instanceof Date)) {


            // Type check expires, fallback to 7 days
            expires = !isNaN(expires) ? expires : 7;

            // Get the expire date instance
            let d = new Date();
            d.setTime(d.getTime() + (expires * 24 * 60 * 60 * 1000));
            expires = d;
        }

        // Set the cookie
        return !!(document.cookie = name + '=' + value + ';' + 'expires=' + expires.toUTCString() + ';path=/');

    },

    /**
     *
     * @param name
     * @returns {*}
     */
    get: function(name) {

        // Build the name
        name += '=';

        // Get cookies
        let decodedCookie = decodeURIComponent(document.cookie);

        // Split cookies to find our cookie
        let ca = decodedCookie.split(';');

        // Loop through cookies
        for (let i = 0; i < ca.length; i++) {

            let c = ca[i];

            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            // Found our cookie, return it
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return document.cookie;
    },

    /**
     *
     * @param name
     * @returns {boolean}
     */
    check: function(name) {
        return !!this.get(name);
    },

    /**
     *
     * @param name
     * @returns {boolean}
     */
    remove: function(name) {
        return !!this.set(name, '', -1);
    },

    /**
     *
     * @returns {boolean}
     */
    enabled: function() {
        return (('cookieEnabled' in navigator && navigator.cookieEnabled) || (this.set('libtestcookie', '1') && this.get('libtestcookie') === '1' && this.remove('libtestcookie')));
    }

};
